<template>
  <div class="homeView flexRow">
    <!-- FIXME - Much better onboarding than this -->
    <!-- <h2 v-if="Object.keys(categories) == 0">Please add a category to get started!</h2>-->

    <!-- FIXME - Add media queries to make this relevant/hidden when appropriate -->
    <!-- FIXME - Figure out why we change styling with/without these wrapper divs -->
    <div class="today">
      <today-view :categories="categories" />
    </div>
    <div class="details">
      <details-view :categories="categories" />
    </div>
  </div>
</template>

<script>
import NewCategory from "../components/NewCategory.vue";

import TodayView from "./TodayView.vue";
import DetailsView from "./DetailsView.vue";

import db from "../db.js";

export default {
  name: "home-view",
  components: {
    "new-category": NewCategory,
    "today-view": TodayView,
    "details-view": DetailsView,
  },
  props: ["categories"],
};
</script>

<style scoped>
.homeView {
  min-width: 600px;
}

@media (max-width: 600px) {
  .homeView.flexRow {
    min-width: auto;
    justify-content: center;
  }
}

.homeView.flexRow {
  align-items: flex-start;
  /*justify-content: space-between;*/
}

/* FIXME - Better ways to actually set this and react to growing content */
.today {
  min-width: 50%;
}

/* FIXME - This seems like a hack...  */
.details {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// HomeView.vue?0849d92f